import { MessageProcessor } from '@/services/websocketProcessorTypes'
import store from '@/redux/store'
import { commonProcessors } from '@/services/websocketProcessors/commonProcessors'
import {
  addMessage,
  setMessages,
  setIsGenerating,
  setError,
  stopStreamingMessages,
} from '@/redux/slices/gameAnalysisSlice'

export const gameAnalysisProcessors: MessageProcessor[] = [
  {
    type: 'populate_messages',
    handler: (data) => {
      if (Array.isArray(data.messages)) {
        const formattedMessages = data.messages.map((msg: any) => ({
          id: msg.message_id || msg.id || Date.now(),
          message: msg.message,
          user: msg.user || 'Game Analysis Assistant',
          streaming: msg.streaming || false,
          filters: msg.filters || undefined,
          llm_provider: msg.llm_provider,
          llm_model_name: msg.llm_model_name,
          created_at: msg.created_at,
        }))

        store.dispatch(setMessages(formattedMessages))
      }
    },
  },
  {
    type: 'bot_response',
    handler: (data) => {
      store.dispatch(
        addMessage({
          id: data.message_id || data.id || Date.now(),
          message: data.message,
          user: data.user || 'Game Analysis Assistant',
          streaming: data.streaming,
          llm_provider: data.llm_provider,
          llm_model_name: data.llm_model_name,
          created_at: data.created_at,
        })
      )
      if (data.streaming) {
        store.dispatch(setIsGenerating(true))
      } else {
        store.dispatch(setIsGenerating(false))
      }
    },
  },

  {
    type: 'bot_response_stopped',
    handler: () => {
      store.dispatch(stopStreamingMessages())
      store.dispatch(setIsGenerating(false))
    },
  },

  {
    type: 'bot_response_error',
    handler: (data) => {
      store.dispatch(setIsGenerating(false))
      store.dispatch(
        setError(data.error || 'An error occurred while generating response')
      )
    },
  },
  {
    type: 'error',
    handler: (data) => {
      store.dispatch(setError(data.message || 'An error occurred'))
    },
  },

  ...commonProcessors,
]
